/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Event } from "./Event";
export const ListAllEventsResponse = core.serialization.object({
    data: core.serialization.list(Event),
});
